import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "add-container-modal-body" }
const _hoisted_2 = { class: "tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "tw-mt-1.5 tw-text-xs tw-text-slate-500"
}
const _hoisted_5 = {
  key: 1,
  class: "tw-mt-2 tw-text-sm tw-text-rose-600"
}
const _hoisted_6 = { class: "tw-mt-1" }
const _hoisted_7 = { class: "tw-mt-1" }
const _hoisted_8 = { class: "md:tw-col-span-2" }
const _hoisted_9 = { class: "tw-mt-6 tw-flex tw-justify-end tw-gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update:isOpen', $event))),
    modalId: "add-container-modal",
    title: "Add Container",
    subtitle: "Fill out container details, then save.",
    maxWidth: "5xl",
    onClose: _ctx.onCancel
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Container Number", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
              placeholder: _ctx.isExportOrder ? 'Optional - leave blank if unknown' : 'ABCD1234567',
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.containerId) = $event)),
              onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onContainerIdBlur && _ctx.onContainerIdBlur(...args)))
            }, null, 40, _hoisted_3), [
              [_vModelText, _ctx.model.containerId]
            ]),
            (_ctx.isExportOrder)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Export orders: leave blank to add a container before the number is known "))
              : _createCommentVNode("", true),
            (_ctx.shouldShowContainerNumberError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Number not valid"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Container Size", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FilterableDropdown, {
                modelValue: _ctx.model.containerSize,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.containerSize) = $event)),
                options: ['20', '24', '38', '40', '45', '53'],
                class: "tw-w-full",
                clearable: false,
                components: { OpenIndicator: null, Deselect: null }
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Container Type", -1)),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_FilterableDropdown, {
                modelValue: _ctx.model.containerType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.containerType) = $event)),
                clearable: false,
                options: ['DS', 'DH', 'FS', 'FH', 'OS', 'OH', 'RS', 'RH'],
                class: "tw-w-full",
                components: { OpenIndicator: null, Deselect: null }
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Seal Number", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
              placeholder: "Seal #",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.sealNumber) = $event))
            }, null, 512), [
              [_vModelText, _ctx.model.sealNumber]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Cargo Pieces", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
              placeholder: "Pieces",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.cargoPieces) = $event))
            }, null, 512), [
              [_vModelText, _ctx.model.cargoPieces]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Weight", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
              placeholder: "Weight",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.weight) = $event))
            }, null, 512), [
              [_vModelText, _ctx.model.weight]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[15] || (_cache[15] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Cargo Description", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
              placeholder: "Description",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.cargoDescription) = $event))
            }, null, 512), [
              [_vModelText, _ctx.model.cargoDescription]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Button, {
            onClick: _ctx.onSave,
            disabled: !_ctx.canSave || _ctx.isSaving,
            enableLoading: _ctx.isSaving,
            class: "tw-h-9",
            icon: "check",
            title: "Save container",
            "aria-label": "Save container"
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode("Save", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled", "enableLoading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "onClose"]))
}